import ActivateDeactivateButton from "@app/components/activate-deactivate-button.tsx";
import ActivateDeactivateIndicator from "@app/components/activate-deactivate-indicator.tsx";
import { ClientModel } from "@app/data/engine.ts";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (id: number) => void;
    onActivateDeactivate: (id: number, active: boolean) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<ClientModel>();
export const clientsTableDefinition = ({ onEdit, onActivateDeactivate, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.clientId!)}>
                <EditIcon />
            </IconButton>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.clientName, { id: "clientName", header: "Client Name" }),
    columnHelper.accessor((x) => x.clientNameShort, { id: "shortName", header: "Short Name" }),
    columnHelper.accessor((x) => x.clientNumber, { id: "clientNumber", header: "Client Number", alignment: "right" }),
    columnHelper.accessor((x) => x.clientCategory, { id: "clientCategory", header: "Client Category" }),
    columnHelper.accessor((x) => x.address?.state, { id: "state", header: "State" }),
    columnHelper.accessor((x) => x.active, {
        id: "active",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Active
                <ActivateDeactivateIndicator />
            </Box>
        ),
        cell: (item) => (
            <ActivateDeactivateButton
                isActive={item.row.original.active!}
                onClick={() => onActivateDeactivate(item.row.original.clientId!, !item.row.original.active)}
            />
        ),
    }),
];
